// extracted by mini-css-extract-plugin
module.exports = {"AdBannerWrap":"adBanner_AdBannerWrap__UPjPN","AdBanner":"adBanner_AdBanner__Dn7v_"};